import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AdministratorFacade, getRolesAndPermission } from '@piqet-angular/data';
import {
  dblclickTooltipDef,
  defaultColumn,
  DELETE_RECORD_LABEL,
  grid_widths_map,
  rolesModuleName,
  subModuleName,
} from '@piqet-angular/shared';
import { right } from '@popperjs/core';
import { ColDef } from 'ag-grid-community';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConversionMappingDataGridService {
  event: any;
  conversionMappingPayload: any;
  editConversionMappingData = new Subject<[any, any, any]>();
  conversionMappingEditObservable$ = this.editConversionMappingData.asObservable();
  deleteConversionMappingData = new Subject<[any, any, any]>();
  conversionMappingDeleteObservable$ = this.deleteConversionMappingData.asObservable();

  constructor(
    public administratorFacade: AdministratorFacade,
    private router: Router,
    private administratorService: AdministratorService,
    private swalService: SwalService
  ) {}

  getConversionMappingColumns(): ColDef[] {
    const colDef: ColDef[] = [];

    colDef.push({
      ...defaultColumn,
      colId: 'MaterialCode',
      headerName: 'Material code',
      field: 'materialCode',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      lockVisible: true,
      wrapHeaderText: true,
      cellStyle: { 'text-decoration': 'underline' },
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.style.cursor = 'pointer';
        cellElement.innerHTML = `${cellValue}`;
        cellElement.title = dblclickTooltipDef;
        cellElement.addEventListener('dblclick', () => {
          this.editConversionMappingData.next([
            params.data.materialId,
            params.data.conversionProcessId,
            'Review conversion mapping detail',
          ]);
        });
        return cellElement;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'MaterialCategory',
      headerName: 'Material category',
      field: 'materialCategory',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      lockVisible: true,
      wrapHeaderText: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'MaterialName',
      headerName: 'Material',
      field: 'materialName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      lockVisible: true,
      wrapHeaderText: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'ConversionCode',
      headerName: 'Conversion code',
      field: 'conversionCode',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      lockVisible: true,
      wrapHeaderText: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'ConversionCategory',
      headerName: 'Conversion category',
      field: 'conversionCategory',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      lockVisible: true,
      wrapHeaderText: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'ConversionProcess',
      headerName: 'Conversion process',
      field: 'conversionProcess',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      lockVisible: true,
      wrapHeaderText: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'OrganizationName',
      headerName: 'Organization',
      field: 'organizationName',
      cellClass: 'my-permission-cursor-pointer',
      // sort: 'asc',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      lockVisible: true,
      wrapHeaderText: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      maxWidth: grid_widths_map.sm_column_xs,
      cellRendererParams: {
        showEdit: this.isAccess() ? this.isAccess().isEdit : true,
        showDelete: this.isAccess() ? this.isAccess().isDelete : true,
        value: 'admin-recycled',
        editData: (data: any) => {
          this.editConversionMappingData.next([
            data.materialId,
            data.conversionProcessId,
            'Review conversion mapping detail',
          ]);
        },
        deleteData: (data: any, pathName: any) => {
          this.deleteConversionMappingConfirmation(data.id, '', pathName);
        },
      },
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'actionRenderer',
      lockVisible: true,
      lockPosition: right,
      resizable: false,
    });
    return colDef;
  }

  isAccess = () => {
    return getRolesAndPermission(
      rolesModuleName.DataManageConversionMapping,
      subModuleName.EOLDataModule
    );
  };

  deleteConversionMappingConfirmation(data: any, customType: any, pathName: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deleteConversionMappingData.next([data, customType, pathName]);
      }
    });
  }
}
